import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GraduwayEvent } from '../../models/data';
import { graduwayEventService } from '../../services';
import { commonActions } from '../commonActions';
import { GraduwayEventState } from './types';

const getGraduwayEvents = createAsyncThunk('graduwayEvents/getGraduwayEvents', async () => {
  return graduwayEventService.getGraduwayEvents();
});

const initialState: GraduwayEventState = {
  graduwayEvents: [],
  loading: false,
  error: null,
};

export const graduwayEventSlice = createSlice({
  name: 'graduwayEvents',
  initialState,
  reducers: {
    updateLoading(state, { payload: { loading } }: PayloadAction<{ loading: boolean }>) {
      state.loading = loading;
    },

    setGraduwayEvents(state, { payload: { graduwayEvents } }: PayloadAction<{ graduwayEvents: GraduwayEvent[] }>) {
      state.graduwayEvents = graduwayEvents;
    },

    updateError(state, { payload: { error } }: PayloadAction<{ error: string | null }>) {
      state.error = error;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGraduwayEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGraduwayEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.graduwayEvents = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(getGraduwayEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Unable to load Graduway events.';
      });

    builder.addCase(commonActions.clearCache.fulfilled, () => {
      return { ...initialState };
    });
  },
});

export const graduwayEventActions = { ...graduwayEventSlice.actions, getGraduwayEvents };

export type GraduwayEventSlice = {
  [graduwayEventSlice.name]: ReturnType<typeof graduwayEventSlice['reducer']>;
};
